import httpService from './http.service';

const regionEndPoint = "order/";
const orderEndPoint = "order/";
const orderChangeEndPoint = "order/";
const orderStatusEndPoint = "bill/"
const billEndPoint = "bill/";

export const ACCOUNT_LINK_SHOPS = Object.freeze(["eshop", "psn", "steam"]);

export const ACCOUNT_LINK_OUTCOMES = Object.freeze({
   EMAIL_SENT: "EMAIL_SENT",
   DELIVERY_FAILED: "DELIVERY_FAILED",
   INVALID_EMAIL: "INVALID_EMAIL",
   RATE_LIMITED: "RATE_LIMITED",
   UNAVAILABLE: "UNAVAILABLE",
   UNKNOWN: "UNKNOWN",
});

export const ACCOUNT_LINK_TIMEOUT_MS = 15000;

function outcomeFromBody(body) {
   if (!body || typeof body !== "object" || Array.isArray(body)) {
      return ACCOUNT_LINK_OUTCOMES.UNKNOWN;
   }
   if (body.status === "EMAIL_SENT") return ACCOUNT_LINK_OUTCOMES.EMAIL_SENT;
   if (body.status === "EMAIL_SEND_FAILED") return ACCOUNT_LINK_OUTCOMES.DELIVERY_FAILED;
   return ACCOUNT_LINK_OUTCOMES.UNKNOWN;
}

function outcomeFromError(error) {
   const status = error?.response?.status;
   if (status === 400) return ACCOUNT_LINK_OUTCOMES.INVALID_EMAIL;
   if (status === 429) return ACCOUNT_LINK_OUTCOMES.RATE_LIMITED;
   return ACCOUNT_LINK_OUTCOMES.UNAVAILABLE;
}



const shopService = {

   getRegionsByShopName: async (region) => {
      const { data } = await httpService.get(`${regionEndPoint}${region}/region/`);
      return data;
   },
   receiveOrderByShopAndRegion: async (shop, params) => {
      const { data } = await httpService.get(`${orderEndPoint}${shop}/`, {
         ...params,
      });
      return data;
   },
   changeOrder: async (body) => {
      const { data } = await httpService.post(`${orderChangeEndPoint}${body?.shopType}/change/`, body);
      return data;
   },
   receiveOrderStatus: async (params) => {
      const { data } = await httpService.get(`${orderStatusEndPoint}${params?.shopType}/status/`, {
         params
      });
      return data;
   },
   generateBill: async (body) => {
      const { data } = await httpService.post(`${billEndPoint}${body?.shopType}/generate/`, body);
      return data;
   },
   requestAccountLink: async ({ shopType, email } = {}) => {
      if (!ACCOUNT_LINK_SHOPS.includes(shopType)) {
         return { outcome: ACCOUNT_LINK_OUTCOMES.UNKNOWN };
      }
      try {
         const response = await httpService.post(
            `account-link/${shopType}/request/`,
            { email },
            { timeout: ACCOUNT_LINK_TIMEOUT_MS }
         );
         return { outcome: outcomeFromBody(response?.data) };
      } catch (error) {
         return { outcome: outcomeFromError(error) };
      }
   },

}

export default shopService;
